import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { HttpClientModule } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
private encryptionKey = CryptoJS.enc.Utf8.parse("25789413578902318017925063274528"); // 32 bytes
private encryptionVector = CryptoJS.enc.Utf8.parse("5178394507931258"); // 16 bytes
public APIKEY: any = "2992c9debd79d6e9";
  
public BaseUrl: any = 'https://api.surveyfreegift.com/webservices/';
public imageurl: any = "https://crm.surveyfreegift.com/uploads/captcha_image/";



  public: any = '';
  public clientlogourl: any = '';

  constructor(
    private http: HttpClient,
    private matSnackBar: MatSnackBar
  ) {
  }

  postApi(data: any, method: any): Observable<any> {

    data.APIKEY = this.APIKEY;
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    //code for encrypt data
    data.APIKEY = this.APIKEY;
    var totaldata = JSON.stringify(data);
    //end code for encrypt data
    var finaldata = this.encode(totaldata);
    return this.http.post<any>(this.BaseUrl + method,finaldata , { headers: headers }).pipe(
      tap((data) => console.log(data)
      
      ),
      catchError(this.handleError<any>('Login'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // alert("Server error/Internet connectivity")
      console.error(error); // log to console instead
      console.log('Failed :: while hit service due to internet or server occurrence');
      return of(result as T);
    };
  }

  showToast(message: string, duration?: number, action?: string,
    hPosition?: any, vPosition?: any,
    className?: any) {

    try {
      this.matSnackBar.open(message, action, {
        duration: duration ? duration : 5000,
        horizontalPosition: hPosition ? hPosition : 'center',
        verticalPosition: vPosition ? vPosition : 'bottom',
        panelClass: className
        // direction: "rtl"
      });
    } catch (error) {

    }

  }


  getData(url: string) {
    return   this.http.get<any>(url);
  }

  encode(data: any) {
    let encrypted = CryptoJS.AES.encrypt(data, this.encryptionKey, { iv: this.encryptionVector }).toString();
    return encrypted;
  }
  decode(encryptedData) {
    let decrypted = CryptoJS.AES.decrypt(encryptedData, this.encryptionKey, { iv: this.encryptionVector });
    let originalData = decrypted.toString(CryptoJS.enc.Utf8);
    return originalData;
  }

}
